import { CheckboxGroup, SearchBox, Text } from '@medly-components/core';
import { InjectClassName } from '@medly-components/utils';
import { DarkOutlinedButton } from 'components/common';
import styled, { css } from 'styled-components';
import { FilterHeaderStyled } from '../FilterHeader/FilterHeader.styled';

export const FooterWrapper = styled(InjectClassName)`
    padding: 1.2rem 2.4rem;
    z-index: 1;
    & > button {
        flex: 1;
    }
`;

export const FiltersWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 100%;
    gap: 1.2rem;
    ${SearchBox.Style} {
        flex: 1;
        background-color: ${({ theme }) => theme.colors.grey[100]};
        svg {
            font-size: 1.8rem;
        }
        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            input::placeholder {
                font-size: 1.4rem;
            }
        }
    }
    ${DarkOutlinedButton} ${Text.Style} {
        display: none;
    }
    ${FilterHeaderStyled}:first-of-type {
        margin-top: 0;
    }
    ${CheckboxGroup.Style} > div {
        margin: 0;
        label:first-of-type {
            padding-top: 0;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        justify-content: flex-end;

        ${SearchBox.Style} {
            max-width: 42.2rem;
            width: 100%;
        }
        ${DarkOutlinedButton} ${Text.Style} {
            display: inline-block;
        }
    }
`;

const appliedFilterDot = css`
    &::after {
        content: '';
        position: absolute;
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.coral[500]};
        top: 0.8rem;
        right: 0.8rem;

        @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
            top: 1rem;
            right: 1rem;
        }
    }
`;

export const FilterButton = styled(DarkOutlinedButton).attrs({ type: 'button' })<{ isFiltersApplied?: boolean }>`
    position: relative;

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding-right: 1.8rem;
    }
    ${({ isFiltersApplied }) => isFiltersApplied && appliedFilterDot}
`;
